import { gql, TypedDocumentNode } from '@common/hooks';
import { TiersFlatType } from './tiers-query';

type SupplierTierQueryVariables = {
  id: string;
};

type SupplierTierQueryResponse = {
  supplier: {
    id: string;
    tierForCurrentOrganization?: TiersFlatType;
  };
};

export const SupplierTierQuery: TypedDocumentNode<
  SupplierTierQueryResponse,
  SupplierTierQueryVariables
> = gql`
  query SupplierTier($id: String!) {
    supplier(id: $id) {
      id
      tierForCurrentOrganization {
        id
        fee
        name
        visibilityOffset
      }
    }
  }
`;
